import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Version } from './_types';

export const fetchVersionHistory = async (
  itemType: string,
  itemId: Identifier
): Promise<Version[]> => {
  const response = await api.get('/api/v4/paper_trail', {
    params: {
      item_type: itemType,
      item_id: itemId,
    },
  });

  return response.data.map((version: any) =>
    camelcaseKeys(version)
  ) as Version[];
};

export const versionQueryKeys = {
  versions: (itemType: string, itemId: Identifier) =>
    ['versions', itemType, itemId] as const,
} as const;
